import { render, staticRenderFns } from "./CustomSidebarNav.vue?vue&type=template&id=8462e588&scoped=true"
import script from "./CustomSidebarNav.vue?vue&type=script&lang=js"
export * from "./CustomSidebarNav.vue?vue&type=script&lang=js"
import style0 from "./CustomSidebarNav.vue?vue&type=style&index=0&id=8462e588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8462e588",
  null
  
)

export default component.exports